// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wKgu1__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background: var(--color-paper-2);
  z-index: 1000;
  overflow-y: auto;
  padding-bottom: 6em;
}

.wKgu1__layout a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.wKgu1__layout a:hover {
      opacity: 0.8;
    }

.l6elY__pageHeader {
  display: flex;
  align-items: center;
  gap: 0.8em;
  padding: 1.5em 1.5em 0;
  max-width: 960px;
  margin: 0 auto;
}

.l6elY__pageHeader a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.l6elY__pageHeader h1 {
    margin: 0;
  }

/* Hero */
.v65Je__hero {
  text-align: center;
  padding: 2.5em 1.5em 1em;
  max-width: 640px;
  margin: 0 auto;
}
.v65Je__hero h2 {
    font-size: 2.5em;
    margin: 0 0 0.3em;
    line-height: 1.1;
  }

.dcbJx__heroSub {
  font-size: 1.15em;
  opacity: 0.85;
}

.dcbJx__heroSub strong {
    font-weight: bold;
  }

/* Pricing Cards */
.XLubQ__cards {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  padding: 1em 1.5em 2em;
  max-width: 720px;
  margin: 0 auto;
  align-items: stretch;
}
@media (min-width: 600px) {
.XLubQ__cards {
    flex-direction: row;
    align-items: flex-start;
}
  }

.U2Aiz__pricingCard {
  flex: 1;
  text-align: center;
  padding: 2em 1.5em;
  border-radius: 16px;
  position: relative;
  --card-compact-padding-x: 0;
  --card-compact-padding-y: 0;
}

.U2Aiz__pricingCard h3 {
    font-size: 1.3em;
    margin: 0.5em 0 0.8em;
    font-weight: 600;
  }

.VrQ8k__featured {
  border: 2px solid var(--color-blue-1);
}

.w2jaM__bestValue {
  position: absolute;
  top: -0.8em;
  left: 50%;
  transform: translateX(-50%);
  background: var(--color-blue-1);
  color: white;
  font-size: 0.8em;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.3em 1.2em;
  border-radius: 100px;
  white-space: nowrap;
}

.m6JVI__cardIcon {
  font-size: 2em;
  color: var(--color-blue-1);
}

.fDR7w__price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.3em;
  margin-bottom: 0.2em;
}

.Bks6W__amount {
  font-size: 2.8em;
  font-weight: 700;
  font-family: var(--heading-font);
  line-height: 1;
}

.dCMkT__period {
  font-size: 0.95em;
  opacity: 0.65;
}

.pXW3j__total {
  font-size: 0.9em;
  opacity: 0.6;
  margin-bottom: 1em;
}

.MzWin__thenFree {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  font-weight: bold;
  font-size: 1.1em;
  color: var(--color-green-1);
  margin-bottom: 1em;
}

.kcdmE__cardNote {
  font-size: 0.85em;
  opacity: 0.65;
  margin: 0;
  padding: 0 0.5em;
}

/* What's Included */
.IklDX__included {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
}
.IklDX__included h2 {
    font-size: 1.8em;
    margin: 0 0 0.3em;
  }

.C7b7b__includedSub {
  margin-bottom: 1.2em;
  opacity: 0.85;
}

.C7b7b__includedSub strong {
    font-weight: bold;
  }

.zGrsj__featureList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7em;
}

.zGrsj__featureList li {
    display: flex;
    align-items: flex-start;
    gap: 0.7em;
    line-height: 1.4;
  }

.XkJFJ__checkIcon {
  color: var(--color-green-1);
  margin-top: 0.25em;
  flex-shrink: 0;
}

/* About lifetime access */
.lixpe__lifetime {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
}
.lixpe__lifetime h2 {
    font-size: 1.8em;
    margin: 0 0 0.5em;
  }
.lixpe__lifetime p {
    margin: 0 0 0.8em;
  }
.lixpe__lifetime strong {
    font-weight: bold;
  }

.eBr4s__lifetimeIcon {
  font-size: 2em;
  color: var(--color-blue-1);
  margin-bottom: 0.3em;
}

/* No Surprises */
.at7k3__noSurprises {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
}
.at7k3__noSurprises h2 {
    font-size: 1.8em;
    margin: 0 0 0.5em;
  }
.at7k3__noSurprises strong {
    font-weight: bold;
  }

.fHQQm__noSurprisesIcon {
  font-size: 2em;
  color: var(--color-green-1);
  margin-bottom: 0.3em;
}

.QjgiM__noSurprisesList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.QjgiM__noSurprisesList li::before {
    content: '—';
    margin-right: 0.5em;
    opacity: 0.4;
  }

/* Footer */
.k5KmT__footer {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
  text-align: center;
  font-size: 0.9em;
  opacity: 0.65;
}
.k5KmT__footer p {
    margin: 0 0 0.5em;
  }
`, "",{"version":3,"sources":["webpack://./src/app/routes/pricing/PricingRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AAWrB;;AATE;IACE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAUhB;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX;;AAGF,SAAS;AACT;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAOhB;AALE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,iBAAiB;EACjB,aAAa;AAKf;;AAHE;IACE,iBAAiB;EACnB;;AAGF,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AAMtB;AAJE;AATF;IAUI,mBAAmB;IACnB,uBAAuB;AAE3B;EADE;;AAGF;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAO7B;;AALE;IACE,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;;AAGF;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AAMpB;AAJE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;AAGF;EACE,oBAAoB;EACpB,aAAa;AAKf;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,UAAU;AAQZ;;AANE;IACE,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,gBAAgB;EAClB;;AAGF;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AAcpB;AAZE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AAEA;IACE,iBAAiB;EACnB;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AAUpB;AARE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,UAAU;AAOZ;;AALE;IACE,YAAY;IACZ,mBAAmB;IACnB,YAAY;EACd;;AAGF,WAAW;AACX;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AAKf;AAHE;IACE,iBAAiB;EACnB","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  background: var(--color-paper-2);\n  z-index: 1000;\n  overflow-y: auto;\n  padding-bottom: 6em;\n\n  & a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n  padding: 1.5em 1.5em 0;\n  max-width: 960px;\n  margin: 0 auto;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n\n/* Hero */\n.hero {\n  text-align: center;\n  padding: 2.5em 1.5em 1em;\n  max-width: 640px;\n  margin: 0 auto;\n\n  & h2 {\n    font-size: 2.5em;\n    margin: 0 0 0.3em;\n    line-height: 1.1;\n  }\n}\n\n.heroSub {\n  font-size: 1.15em;\n  opacity: 0.85;\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n/* Pricing Cards */\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5em;\n  padding: 1em 1.5em 2em;\n  max-width: 720px;\n  margin: 0 auto;\n  align-items: stretch;\n\n  @media (min-width: 600px) {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n}\n\n.pricingCard {\n  flex: 1;\n  text-align: center;\n  padding: 2em 1.5em;\n  border-radius: 16px;\n  position: relative;\n  --card-compact-padding-x: 0;\n  --card-compact-padding-y: 0;\n\n  & h3 {\n    font-size: 1.3em;\n    margin: 0.5em 0 0.8em;\n    font-weight: 600;\n  }\n}\n\n.featured {\n  border: 2px solid var(--color-blue-1);\n}\n\n.bestValue {\n  position: absolute;\n  top: -0.8em;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--color-blue-1);\n  color: white;\n  font-size: 0.8em;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 0.3em 1.2em;\n  border-radius: 100px;\n  white-space: nowrap;\n}\n\n.cardIcon {\n  font-size: 2em;\n  color: var(--color-blue-1);\n}\n\n.price {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 0.3em;\n  margin-bottom: 0.2em;\n}\n\n.amount {\n  font-size: 2.8em;\n  font-weight: 700;\n  font-family: var(--heading-font);\n  line-height: 1;\n}\n\n.period {\n  font-size: 0.95em;\n  opacity: 0.65;\n}\n\n.total {\n  font-size: 0.9em;\n  opacity: 0.6;\n  margin-bottom: 1em;\n}\n\n.thenFree {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5em;\n  font-weight: bold;\n  font-size: 1.1em;\n  color: var(--color-green-1);\n  margin-bottom: 1em;\n}\n\n.cardNote {\n  font-size: 0.85em;\n  opacity: 0.65;\n  margin: 0;\n  padding: 0 0.5em;\n}\n\n/* What's Included */\n.included {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n\n  & h2 {\n    font-size: 1.8em;\n    margin: 0 0 0.3em;\n  }\n}\n\n.includedSub {\n  margin-bottom: 1.2em;\n  opacity: 0.85;\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.featureList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7em;\n\n  & li {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.7em;\n    line-height: 1.4;\n  }\n}\n\n.checkIcon {\n  color: var(--color-green-1);\n  margin-top: 0.25em;\n  flex-shrink: 0;\n}\n\n/* About lifetime access */\n.lifetime {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n\n  & h2 {\n    font-size: 1.8em;\n    margin: 0 0 0.5em;\n  }\n\n  & p {\n    margin: 0 0 0.8em;\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.lifetimeIcon {\n  font-size: 2em;\n  color: var(--color-blue-1);\n  margin-bottom: 0.3em;\n}\n\n/* No Surprises */\n.noSurprises {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n\n  & h2 {\n    font-size: 1.8em;\n    margin: 0 0 0.5em;\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.noSurprisesIcon {\n  font-size: 2em;\n  color: var(--color-green-1);\n  margin-bottom: 0.3em;\n}\n\n.noSurprisesList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n\n  & li::before {\n    content: '—';\n    margin-right: 0.5em;\n    opacity: 0.4;\n  }\n}\n\n/* Footer */\n.footer {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n  text-align: center;\n  font-size: 0.9em;\n  opacity: 0.65;\n\n  & p {\n    margin: 0 0 0.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `wKgu1__layout`;
export var pageHeader = `l6elY__pageHeader`;
export var hero = `v65Je__hero`;
export var heroSub = `dcbJx__heroSub`;
export var cards = `XLubQ__cards`;
export var pricingCard = `U2Aiz__pricingCard`;
export var featured = `VrQ8k__featured`;
export var bestValue = `w2jaM__bestValue`;
export var cardIcon = `m6JVI__cardIcon`;
export var price = `fDR7w__price`;
export var amount = `Bks6W__amount`;
export var period = `dCMkT__period`;
export var total = `pXW3j__total`;
export var thenFree = `MzWin__thenFree`;
export var cardNote = `kcdmE__cardNote`;
export var included = `IklDX__included`;
export var includedSub = `C7b7b__includedSub`;
export var featureList = `zGrsj__featureList`;
export var checkIcon = `XkJFJ__checkIcon`;
export var lifetime = `lixpe__lifetime`;
export var lifetimeIcon = `eBr4s__lifetimeIcon`;
export var noSurprises = `at7k3__noSurprises`;
export var noSurprisesIcon = `fHQQm__noSurprisesIcon`;
export var noSurprisesList = `QjgiM__noSurprisesList`;
export var footer = `k5KmT__footer`;
export default ___CSS_LOADER_EXPORT___;
